// FIXME: 추후 팔레트 별 관리할 수 있도록 수정해야함.
// FIXME: 디폴트, 다크모드 제공 단계 필요
/**
 * # Colors
 *
 * 색상 팔레트
 */
export var Colors = {
    PRIMARY: {
        BACKGROUND: '#ffffff',
        ACCENT_1: '#FAFAFA',
        ACCENT_2: '#EAEAEA',
        ACCENT_3: '#999',
        ACCENT_4: '#888',
        ACCENT_5: '#666',
        ACCENT_6: '#444',
        ACCENT_7: '#333',
        ACCENT_8: '#111',
        FOREGROUND: '#000'
    },
    ERROR: {
        LIGHTER: '#F7D4D6',
        LIGHT: '#FF1A1A',
        DEFAULT: '#E00',
        DARK: '#C50000'
    },
    SUCCESS: {
        LIGHTER: '#D3E5FF',
        LIGHT: '#3291FF',
        DEFAULT: '#0070F3',
        DARK: '#0761D1'
    },
    WARNING: {
        LIGHTER: '#FFEFCF',
        LIGHT: '#F7B955',
        DEFAULT: '#F5A623',
        DARK: '#AB570A'
    },
    VIOLET: {
        LIGHTER: '#D8CCF1',
        LIGHT: '#8A63D2',
        DEFAULT: '#7928CA',
        DARK: '#4C2889'
    },
    CYAN: {
        LIGHTER: '#AAFFEC',
        LIGHT: '#79FFE1',
        DEFAULT: '#50E3C2',
        DARK: '#29BC9B'
    },
    HIGHLIGHT: {
        PURPLE: '#F81CE5',
        MAGENTA: '#EB367F',
        ORANGE: '#FF6600',
        YELLOW: '#FFF500'
    }
};
/**
 * # Layers
 *
 * z-index 우선순위를 사용할 수 있도록 제공
 */
export var Layers = {
    /** 백그라운드 */
    BACKGROUND: -1,
    /** 기본 */
    STANDARD: 0,
    /** 기본 */
    AFTER_STANDARD: 10,
    /** 앞 배경 */
    FOREGROUND: 100,
    /** 모달 */
    MODAL: 1000,
    /** 로딩 */
    LOADING: 2000,
    /** 스넥바 */
    SNACKBAR: 3000,
    /** input등 요소들이 안보여야하는 경우, 지정하고 화면 밖으로 컬링해서 빼버림 */
    CONCEAL: 9999
};
export var Shadows = function (isDark) {
    var rgb = isDark ? '255' : '0';
    var smallColor = "rgba(".concat(rgb, ", ").concat(rgb, ", ").concat(rgb, ", 0.1)");
    var otherColor = "rgba(".concat(rgb, ", ").concat(rgb, ", ").concat(rgb, ", 0.12)");
    return {
        SMALLEST: "0 2px 4px ".concat(smallColor),
        EXTRA_SMALL: "0 4px 8px ".concat(otherColor),
        SMALL: "0 5px 10px ".concat(otherColor),
        MEDIUM: "0 8px 30px ".concat(otherColor),
        LARGE: "0 30px 60px ".concat(otherColor),
        HOVER: "0 30px 60px ".concat(otherColor)
    };
};
//# sourceMappingURL=type.js.map